// Edit a task (A5U7), owned by hand: the loader warms the task and the members through the queries the form reads; a
// save or Cancel goes back to the task.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../../../../components/ui/page-header'
import { membersQuery } from '../../../../../features/members/queries'
import { taskQuery } from '../../../../../features/tasks/queries'
import { TaskEdit } from '../../../../../features/tasks/TaskEdit'
import { Part } from '../../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/tasks/$taskId/edit')({
  staticData: { screenId: 'TaskEditScreen', access: 'task.create or task.update.*' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    await Promise.all([
      queryClient.ensureQueryData(taskQuery(membership.orgId, params.taskId)),
      queryClient.ensureQueryData(membersQuery(membership.orgId)),
    ])
    return { orgId: membership.orgId }
  },
  component: TaskEditScreen,
})

function TaskEditScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const params = Route.useParams()
  const navigate = Route.useNavigate()
  return (
    <main data-testid={ids.taskEdit.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('tasks.edit.title')} />
      <Part testId={ids.taskEdit.skeleton}>
        <TaskEdit
          orgId={orgId}
          orgSlug={params.orgSlug}
          taskId={params.taskId}
          onDone={() => void navigate({ to: '/o/$orgSlug/tasks/$taskId', params })}
        />
      </Part>
    </main>
  )
}
